import { EmptyStateProps } from "./emptyState.interface";
import Button from "../button/button.index";
import { ButtonType } from "../button/button.interface";

export default function EmptyState(props: EmptyStateProps): JSX.Element {
    return (
        <div className="h-full w-full flex flex-col items-center justify-center">
            <img src={props.icon} alt="empty state" className="max-w-[400px]" />
            <h3 className="mb-4 mt-4 font-bold text-[16px] text-secondary-800">{props.title}</h3>
            <p className="mb-4 text-[14px] text-secondary-500 max-w-[500px] text-center leading-8">{props.text}</p>
            {props.buttonText && <Button onClick={props.buttonAction} text={props.buttonText} type={ButtonType.SECONDARY} autoFocus={false} />}
        </div>
    );
}
